import styled from "styled-components/macro";
import { Button, Typography } from "@material-ui/core";
import CancelIcon from "@material-ui/icons/Cancel";

import { CheckCircleOutline } from "@material-ui/icons";
import Select from "@material-ui/core/Select";

const StyledHeader = styled(Typography).attrs(() => ({
  component: "h1",
  variant: "h5",
}))`
  &&& {
    text-align: center;
    margin-bottom: 20px;
    font-weight: 600;
  }
`;

const MySelect = styled(Select)`
  border: 1px solid #c4c4c4;
  padding: 5px;
  height: 31px;
  margin-top: 6px;
  border-radius: 4px;
  // border-bottom: none;
`;

const FormContainer = styled.div`
  padding: 40px;
`;

const DetailsForm = styled.form`
  width: 100%;
  margin: 0 auto;
`;

const LocationContainer = styled.div`
  display: flex;
  justify-content: space-between;
`;

const StyledSelectLocationButton = styled(Button).attrs(() => ({
  variant: "contained",
}))`
  &&& {
    background-color: #ef403b;
    color: white;
    margin-top: 10px;
  }
`;

const HelperText = styled.div`
  color: #f44336;
  margin: 0 0 0 14px;
  font-size: 12px;
`;

// TO DO: Rewrite to button
const DeleteButton = styled.div`
  position: absolute;
  right: -30px;
  top: 18px;
  color: red;
  cursor: pointer;
  display: inline-block;
  opacity: 0.8;
`;

const AddMoreButton = styled.div`
  margin-bottom: 10px;
  cursor: pointer;
  display: inline-block;
  color: #4068c2;
`;

const DeleteIconButton = styled.div`
  color: #100f0f;
  position: absolute;
  top: -6px;
  left: 22px;
  cursor: pointer;
  background-color: #fff;
  padding: 0px;
  width: 0px;
  height: 0px;
`;

const FileWrapper = styled.div`
  display: flex;
  margin: 10px 0;
  align-items: center;
`;

const StyledAddPictureButton = styled(Button)`
  &&& {
    background: white;
    outline: none;
    cursor: pointer;
    padding: 5px 20px;
    color: #ef403b;
    border: 1px solid #ef403b;
    border-radius: 5px;
    text-transform: capitalize;

    &:disabled {
      opacity: 0.6;
      cursor: not-allowed;
    }
  }
`;

const UploadedFile = styled.div`
  width: 35px;
  height: 35px;
  margin-left: 40px;
  position: relative;
  border-radius: 3px;
  border: 2px solid red;
  background-size: cover;
`;

const StyledCancelIcon = styled(CancelIcon)`
  &&& {
    background-color: white;
    border-radius: 5px;
    height: 15px;
    width: 15px;
  }
`;

const TimingHeader = styled.div`
  margin-bottom: 10px;
  font-size: 15px;
`;

const ButtonsContainer = styled.div`
  // width: 50%;
  // margin: 20px auto;
  display: flex;
  justify-content: center;
  position: absolute;
  bottom: 30px;
  left: 0;
  right: 0;
  margin-bottom: 0;
`;

const StyledCancelButton = styled(Button).attrs(() => ({
  variant: "contained",
}))`
  &&& {
    background-color: white;
    color: #ef403b;
    border: 1px solid #ef403b;
    //width: 155px;
    padding: 5px 30px !important;
    border-radius: 8px !important;
    font-weight: bold !important;
    margin: 10px !important;
  }
`;

const StyledSaveButton = styled(Button).attrs(() => ({ varian: "contained" }))`
  &&& {
    background-color: #ef403b;
    color: white;
    //width: 142px;
    padding: 5px 30px !important;
    border-radius: 8px !important;
    font-weight: bold !important;
    margin: 10px !important;
  }
`;

const StyledTextButton = styled(Button).attrs(() => ({}))`
  &&& {
    color: #ef403b;
    // //width: 142px;
    padding: 5px 30px !important;
    border-radius: 8px !important;
    font-weight: bold !important;
    margin: 10px !important;
  }
`;

const SuccessWrapper = styled.div`
  padding: 11px 17px 11px 11px;
  background: #e4fcea;
  border-radius: 3px;
  display: inline-flex;
  line-height: 1;
  align-items: center;
  font-weight: 700;
  margin-top: 10px;
  margin-bottom: 10px;
`;

const StyledCheckCircleOutline = styled(CheckCircleOutline)`
  &&& {
    color: #1bb55c;
    // cursor: pointer;
    margin-right: 5px;
  }
`;

export {
  StyledHeader,
  FormContainer,
  DetailsForm,
  LocationContainer,
  StyledSelectLocationButton,
  HelperText,
  DeleteButton,
  AddMoreButton,
  FileWrapper,
  UploadedFile,
  StyledAddPictureButton,
  DeleteIconButton,
  StyledCancelIcon,
  TimingHeader,
  ButtonsContainer,
  StyledCancelButton,
  StyledSaveButton,
  StyledTextButton,
  MySelect,
  SuccessWrapper,
  StyledCheckCircleOutline,
};
